export default class ShopHeader extends HTMLElement {
  constructor() {
    super()
  }
}

customElements.define('shop-header', ShopHeader)
